<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px;z-index: -1;"></div>
    <el-image v-if="swiperList && swiperList.length!=0"
              style="min-width: 1200px;height:463px;"
              :src="swiperList[0].resourceUrl"
              alt=""></el-image>
    <!-- 公司简介 -->
    <div class="box">
      <div class="currency_box">
        <curTitle color="#333333"
                  :data="{title:'公司简介',content:'新零售实体门店，一站式解决方案'}"></curTitle>
      </div>
      <div class="currency_box"
           style="margin-top:40px">
        <div class="item"
             v-for="(item,index) in list"
             :key="index">
          <div style="width:100%;"
               class="flexCenter">
            <div style="width:48px;height:48px;background-color: #fff;margin-bottom: 14px;">
              <el-image :src="$imgUrl + item.img"></el-image>
            </div>
          </div>
          <div class="num mainColor"> <span class="font36">{{item.num}}</span> <span class="font20">{{item.company}}</span> </div>
          <div>{{item.title}}</div>
        </div>
      </div>
      <div class="currency_box"
           style="margin-top:50px">
        成立于2011年的钧策咨询，从定位于零售企业经营业绩提升的公司，经过十年的沉淀，目前已经发展成为集线上课程，线下培训，企业咨询服务为一体的综合性企业。公司 成立以来，秉承务实创新分享合作的核心价值观，以成为中国广受尊重的咨询机构为愿景，以帮助中国企业争创一流，建立持续发展核心优势为使命；坚持对外成就客户， 对内成就员工的核心理念，服务于零售行业。
      </div>
      <div class="logo_box">
        <div class="left_bg">
        </div>
        <div class="right_bg"></div>
        <div class="currency_boxs">
          <div class="picList_box"
               @mousewheel="wheel">
            <div class="picList">
              <div class="picItem"
                   v-for="item in 76"
                   :key="item+'i'"
                   @mouseenter="mouseover(item)">
                <div class="logoImg_box">
                  <el-image class="logoImg"
                            :style="{'transform':logoIndex==item?'scale(1.3)':''}"
                            :src="item<10?$imgUrl + 'home/logo/0' + item +'.png':$imgUrl + 'home/logo/' + item +'.png'"
                            alt=""
                            srcset=""></el-image>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 企业文化 -->
    <div class="culture_box">
      <div class="currency_box">
        <curTitle color="#333333"
                  :data="{title:'企业文化'}"></curTitle>
      </div>
      <div class="currency_box"
           style="margin-bottom:40px">
        <culture></culture>
      </div>
    </div>
    <!-- 发展历程 -->
    <div class="history_box">
      <div class="currency_box">
        <curTitle color="#333333"
                  :data="{title:'发展历程',content:'新零售实体门店，一站式解决方案'}"></curTitle>
      </div>
      <div class="currency_box"
           style="padding-top: 40px;">
        <div class="flexCenter yearList">
          <div class="yearitem"
               :style="{'fontSize':yearIndex == index?'36px':'28px','color':yearIndex==index? '#DE1F26' :'#FFABAE'}"
               v-for="(item,index) in yearList"
               :key="index"
               @click="yearClick(index)">
            {{item.title}}
          </div>
        </div>
      </div>
      <div class="currency_box">
        <div class="flexCenter yearList lineList">
          <div class="yearitem lineitem"
               v-for="(item,index) in yearList"
               :key="index"
               @click="yearClick(index)">
            <div class="line"
                 :style="{'width':yearIndex == index?'16px':'8px','height':yearIndex == index?'16px':'8px','backgroundColor':yearIndex==index? '#DE1F26' :'#FFABAE'}"></div>
          </div>
        </div>
      </div>
      <div class="currency_box"
           style="margin-top:60px;overflow: hidden;position: relative;">
        <div class="icon leftIcon"
             v-if="yearIndex != 0"
             @click="iconClick('left')">
          <i class="el-icon-arrow-left font30
"></i>
        </div>
        <div class="icon rightIcon"
             v-if="(yearIndex != yearList.length-1)"
             @click="iconClick('right')">
          <i class="el-icon-arrow-right font30
"></i>
        </div>
        <div style="width:300%;display: flex;"
             :style="{'marginLeft':(yearIndex*-400)+'px'}">
          <div v-for="(item,index) in yearList"
               :key="index">
            <div style="width:300px;margin:0 50px;">
              <div style="font-weight:600;font-size: 20px;">{{item.title}}年</div>
              <div v-for="(x,y) in item.list"
                   :key="y+'y'">
                <div class="year_title">{{x.title}}</div>
                <div class="year_content font16">{{x.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新闻资讯 -->
    <div class="news_box">
      <div class="currency_box">
        <curTitle color="#333333"
                  :data="{title:'新闻资讯'}"></curTitle>
      </div>
      <div class="currency_box">
        <news :list="wxlist"></news>
      </div>
    </div>
  </div>
</template>

<script>
import curTitle from '@/components/home/cur_title.vue'
import culture from './components/culture.vue'
import news from './components/news.vue'
import {
  resourceList, wxArticle
} from '@/api/api.js'
export default {
  components: { curTitle, culture, news },
  data () {
    return {
      logoIndex: -1,
      wxlist: [],
      swiperList: [],
      data: {
        showIndex: 8,
        pageNumber: 1,
        pageSize: 100
      },
      wxArticleData: {
        pageNumber: 1,
        pageSize: 30
      },
      yearList: [{
        title: '2022', list: [
          {
            title: '6月', content: "于武汉举办第30届总裁峰会，与全国零售企业探讨时代交叠与创新增长，帮助企业穿越商业周期，蜕变转型成为更好的'自己'同年自研平台'线上商学院'推向市场，帮助更多的零售企业搭建线上商学院，实现人才培养层面的降本增效同年零售私享会的创立，打造一个只属于零售行业的高能量圈子，干货分享、研报下载、专家答疑等服务帮助圈子成员提升认知，解决问题！为更好的帮助企业业绩提升，管理提效，钧策咨询开启了系列直播服务，每周2- 3期围绕不同话题分享交流！"
          }
        ]
      }, {
        title: '2021', list: [
          {
            title: '3月', content: "于武汉举办第27届中国零售总裁峰会，并在同期邀请行业嘉宾开启私董会启动仪式同年将走进标杆系列课程、走进卖场实操课程做出优化并在全国巡回举办，受到广大学员的认可"
          },
          {
            title: '6月', content: "恰逢钧策咨询10周年，将第28届总裁峰会与公司庆典邀请近千位零售人共同见证，探讨《数字赋能 · 协同共生 | 超级链接开启智慧零售时代》"
          },
          {
            title: '11月', content: "与郑州百荣市场共同举办第29届总裁峰会，围绕数字零售时代的变与不变进行探讨交流，提升认知的同时获取最新商品资源，为春节业绩提升做充足准备"
          }
        ]
      }, {
        title: '2020',
        list: [
          {
            title: '1月23日',
            content: '武汉封城'
          },
          {
            title: '2月3日',
            content: '恢复线上办公，线上赋能零售业'
          },
          {
            title: '5月',
            content: '首期线下课程顺利开启'
          },
          {
            title: '6月',
            content: '推出社群爆品课程'
          },
          {
            title: '11月',
            content: '第26届总裁峰会正式转型线上线下一体化'
          }

        ]
      }, {
        title: '2019',
        list: [
          {
            title: '3月',
            content: '第二十三届总裁峰会报名突破1000人'
          },
          {
            title: '6月',
            content: '钧易科技公司成立'
          },
          {
            title: '8月',
            content: '举办首期新商业盈利系统'
          },
          {
            title: '10月',
            content: '孵化出钧正项目公司'
          },
          {
            title: '11月',
            content: '举办24届峰会升级钧策商学院，推出四大飞轮体系'
          },
          {
            title: '12月',
            content: '推出公司1.0-4.0生态战略'
          }
        ]
      }, {
        title: '2018',
        list: [
          {
            title: '1月',
            content: '升级公司产品体系，打造出经营、管理、财务三大系统;举办团队执行力训练营'
          },
          {
            title: '3月',
            content: '举办第二十届总裁峰会，“钧策商学院”正式成立'
          },
          {
            title: '5月8日',
            content: '钧创咨询公司成立'
          }
        ]
      }, {
        title: '2017',
        list: [
          {
            title: '1月',
            content: '内部推行股权激励改革'
          },
          {
            title: '2月',
            content: '钧策合伙事业部开启'
          },
          {
            title: '3月',
            content: '举办第16届零售总裁峰会，首次突破500人'
          },
          {
            title: '8月',
            content: '内部变革取得卓有成效，八个月即完成全年销售总目标。'
          }
        ]
      }, {
        title: '2016',
        list: [
          {
            title: '3月',
            content: '推出符合零售行业移动信息系统'
          },
          {
            title: '5月',
            content: '游学日本深度考察零售业'
          },
          {
            title: '6月',
            content: '推出老板财务管控课程'
          },
          {
            title: '10月',
            content: '迁至光谷世贸中心大楼'
          },
          {
            title: '12月',
            content: '率先走进台湾考察便利店'
          }
        ]
      }, {
        title: '2015',
        list: [
          {
            title: '4月',
            content: '第九届总裁峰会将股权激励引入零售行业'
          },
          {
            title: '5月',
            content: '推出自采课程，率先开启厂商直供模式'
          },
          {
            title: '6月',
            content: '首次推出合伙人方案班'
          },
          {
            title: '8月',
            content: '第十届零售总裁峰会推出“互联网+零售”战略'
          },
        ]
      }, {
        title: '2014',
        list: [
          {
            title: '4月',
            content: '首推零售互联网转型+资本转型主题培训'
          },
          {
            title: '6月',
            content: '首推走进标杆企业课程'
          },
          {
            title: '8月',
            content: '推出手机经营助手'
          },
          {
            title: '10月',
            content: '成立北京钧策'
          },
          {
            title: '11月',
            content: '第七届零售总裁峰会提出“重塑零售商业模式”'
          }
        ]
      }, {
        title: '2013',
        list: [
          {
            title: '5月',
            content: '成立渠道拓展中心'
          },
          {
            title: '10月',
            content: '筹备首个27000平卖场开业，全年举办线下课程超过100场  '
          },
          {
            title: '11月',
            content: '优化组织推行“人单合一”'
          }
        ]
      }, {
        title: '2012',
        list: [
          {
            title: '3月',
            content: '推出零售商学院'
          },
          {
            title: '5月',
            content: '推出针对连锁超市系列课程'
          },
          {
            title: '9月',
            content: '第一个项目开启'
          },
          {
            title: '10月',
            content: '举办第三届总裁峰会引入“阿米巴”机制'
          }
        ]
      }, {
        title: '2011', list: [
          {
            title: '3月',
            content: '公司于武汉成立'
          },
          {
            title: '6月',
            content: '钧策咨询正式营业11月成功举办第一届零售总裁峰会'
          }
        ]
      },
      ],
      yearIndex: 0,
      list: [{ num: 11, company: '年', title: '专注中国零售实体企业', img: 'aboutUs/NF_img.png' }, { num: 1300, company: '家', title: '优质会员数量超', img: 'aboutUs/HY_img.png' }, { num: 500, company: '余家', title: '每年进行门店升级调整', img: 'aboutUs/QY_img.png' }, { num: 23, company: '省', title: '客户覆盖全国', img: 'aboutUs/DT_img.png' }]
    }
  },
  created () {
    this.list[0].num = new Date().getFullYear() - 2011;
    this.getresourceList()
    this.getwxArticle()
  },
  methods: {
    iconClick (type) {
      if (type == 'left') {
        this.yearIndex--
      } else {
        this.yearIndex++
      }
    },
    mouseover (index) {
      this.logoIndex = index;
    },
    yearClick (index) {
      this.yearIndex = index;
    },
    async getresourceList () {  //获取首页资源
      const res = await resourceList(this.data)
      console.log(res)
      this.swiperList = res.data;
    },
    async getwxArticle () {  //新闻资讯
      const res = await wxArticle(this.wxArticleData)
      console.log(res)
      this.wxlist = this.split_array(res.data.records, 4)
    },
    split_array (array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength));
      }
      // console.log(newArray)
      return newArray;
    },
    wheel (e) {
      console.log(e)
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  min-height: 100vh;
  .rightIcon {
    position: absolute;
    right: 0;
  }
  .leftIcon {
    position: absolute;
    left: 0;
  }
  .icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
  }
  .news_box {
    padding: 48px 0 0 50px 0;
  }
  .year_title {
    font-family: 'bb';
    margin: 10px 0;
    color: #333;
  }
  .year_content {
    color: #666666;
  }
  .history_box {
    background-color: #fff;
    min-width: 1200px;
    padding: 50px 0;
    box-sizing: border-box;
    .lineList {
      margin-top: 14px;
      height: 2px;
      width: 100%;
      background-color: #de1f26;
      .lineitem {
        display: flex;
        justify-content: center;
        .line {
          border-radius: 50%;
        }
      }
    }
    .yearList {
      width: 100%;
      // padding: 0 80px;
      box-sizing: border-box;
      .yearitem {
        cursor: pointer;
        font-family: 'bb';
        flex: 1;
        text-align: center;
        font-weight: bold;
      }
    }
  }
  .culture_box {
    width: 100%;
    background-color: #f6f6f6;
  }
  .box {
    min-width: 1200px;
    background-color: #fff;
    padding: 40px 0;
    box-sizing: border-box;
    font-family: 'bb';
    .item {
      text-align: center;
      flex: 1;
    }
    .picList_box::-webkit-scrollbar {
      height: 0 !important;
    }
    // @keyframes myfirst {
    //   0% {
    //     background: red;
    //     left: 0px;
    //     top: 0px;
    //   }

    //   100% {
    //     background: blue;
    //     left: 200px;
    //     top: 0px;
    //   }

    // }
    .logo_box {
      width: 100%;
      position: relative;
      .left_bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 36%;
        height: 100%;
        background: url('https://www.dtyunxi.com/images/index_fgh11.png')
          no-repeat right center;
        background-size: cover;
        z-index: 5;
      }
      .right_bg {
        position: absolute;
        right: 0;
        top: 0;
        width: 36%;
        height: 100%;
        background: url('https://www.dtyunxi.com/images/index_fgh12.png')
          no-repeat left center;
        background-size: cover;
        z-index: 5;
      }
    }
    .picList_box {
      margin-top: 40px;
      width: 100%;
      background-color: #f6f6f6;
      padding: 15px 0 0 15px;
      // box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
      overflow: hidden;
      .picList {
        width: 400%;
        // left: -100px;
        // flex-wrap: wrap;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        // box-shadow: 10px;
        visibility: visible;
        animation-duration: 2s;
        animation-delay: 0.2s;
        animation: scroll 40s linear infinite; /*滚动动画*/
        .picItem {
          // float: left;
          // display: inline-block;
          width: calc((100% - 234px) / 19);
          height: 130px;
          // padding: 30px 0;
          box-sizing: border-box;
          background-color: #fff;
          color: #000;
          text-align: center;
          margin-right: 11px;
          margin-bottom: 11px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 21px 0;
          box-sizing: border-box;
          cursor: pointer;
          .logoImg_box {
            overflow: hidden;
            .logoImg {
              width: 100%;
              height: 100%;
              transition: all 3s;
            }
          }
          // animation: scroll 20s linear infinite; /*滚动动画*/
        }
        .picitem:nth-child(19n) {
          margin-right: 0;
        }
      }
      .picList:hover {
        -webkit-animation-play-state: paused;
        animation-play-state: paused;
      }
      @keyframes scroll {
        from {
          transform: translateX(0); /*div多宽就写多宽*/
        }

        to {
          transform: translateX(-75%);
        }
      }
    }
  }
}
</style>
